import { useEffect, useState } from "react";
import "./projects.css";
import { Animated } from "react-animated-css";
import firebase from "../config.js";

function goToElement() {
  var hash = document.location.hash;
  if (hash.length > 0) {
    // console.log(hash);
    // console.log(document.querySelector(hash + '-check'))
    if (document.querySelector(hash + "-check") != undefined) {
      document.querySelector(hash + "-check").checked = true;
    }
  }
}

export default function Projects(props) {
  var [projects, setprojects] = useState([]),
    projs = [];
  useEffect(() => {
    firebase
      .firestore()
      .collection("projects")
      .get()
      .then((doc) => {
        // console.log(doc.docs.length);
        doc.docs.forEach((d, k) => {
          // console.log(d.data().tags);
          if (d.data().tags != undefined) {
            var tags = [],
              tgs = d.data().tags.split(",");
            tgs.forEach((e, k) => {
              if (e.length > 0) tags.push(<span key={k + "proj"}>{e}</span>);
            });
            projs.push(
              <div key={k + "projj"}>
                <label htmlFor={d.id.replaceAll(" ", "-") + "-check"}>
                  <input
                    type="checkbox"
                    className="project-check"
                    id={d.id.replaceAll(" ", "-") + "-check"}
                    key={k + "input"}
                    onChange={(e) => {
                      if (e.target.checked) {
                        // document.body.style.overflow = "hidden";
                        document.location.hash = d.id.replaceAll(" ", "-");
                      } else {
                        // document.body.style.overflow = "auto";
                        // document.location.hash = ''
                      }
                    }}
                  />
                  <div className="project-pics" id={d.id.replaceAll(" ", "-")}>
                    <div>
                      <img
                        loading="lazy"
                        src={`./uploads/${d.id}.jpg`}
                        alt={`${d.id}`}
                        onError={(event) =>
                          (event.target.style.display = "none")
                        }
                      />
                      {d.data().pics !== undefined
                        ? d
                            .data()
                            .pics.map((e, k) => (
                              <img
                                loading="lazy"
                                key={k + "proj-img"}
                                src={`./uploads/${d.id + e}.jpg`}
                                alt={`${d.id + e}`}
                              />
                            ))
                        : d
                            .data()
                            ?.images?.map((e, k) => (
                              <img
                                loading="lazy"
                                src={e}
                                alt={`${d.id + k}`}
                                key={k + "proj-img"}
                              />
                            ))}
                      {d.data().linkDisplay !== undefined &&
                        d.data().linkDisplay && (
                          <a href={d.data().link} className="modal-link">
                            Visit {d.id} Demo
                          </a>
                        )}
                    </div>
                  </div>
                </label>
                <div
                  className={`project ${d.data().type} all`}
                  style={{ backgroundSize: "cover" }}
                >
                  <label
                    className="project-label"
                    htmlFor={d.id.replaceAll(" ", "-") + "-check"}
                  >
                    <div>
                      <img
                        loading="lazy"
                        src={d.data()?.thump || `./uploads/${d.id}.jpg`}
                        alt={`${d.id}`}
                      />
                      {/* <div> */}
                      <Animated
                        className="info"
                        animationIn="pulse"
                        // animationOut='zoomOutDown'
                        animationInDuration={600}
                        // animationOutDuration={600}
                        isVisible={true}
                      >
                        <p>{d.data().info}</p>
                        <div className="tags">{tags}</div>
                      </Animated>
                      {/* </div> */}
                    </div>
                    <div style={{ backgroundSize: "cover" }}>
                      <a>{d.id}</a>
                    </div>
                  </label>
                </div>
              </div>
            );
            goToElement();
          }
        });
        setprojects(projs);
        // props.callback()
      })
      .catch((e) => console.log(e));
  }, []);

  return (
    <div id="projects">
      <div id="projects_con" style={{ textAlign: "center" }}>
        {projects}
      </div>
    </div>
  );
}
